import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from '../api';
import { Logo } from '../ui';

/** The page a sign-in link opens. The token is in the #fragment; it is POSTed once and removed from the address bar. */
export function Verify() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return; // StrictMode runs effects twice; the token is single-use
    started.current = true;
    const token = new URLSearchParams(location.hash.slice(1)).get('token');
    history.replaceState(null, '', location.pathname);
    if (!token) {
      setError('This link has no sign-in token. Ask for a new one.');
      return;
    }
    api('/v1/auth/verify', { method: 'POST', json: { token } })
      .then(async () => {
        await qc.invalidateQueries();
        navigate({ to: '/streams', replace: true });
      })
      .catch((err) => setError(err instanceof ApiError ? err.message : 'Sign-in failed. Ask for a new link.'));
  }, [navigate, qc]);

  return (
    <div className="center">
      <div className="auth">
        <div className="brand">
          <Logo />
        </div>
        <div className="card">
          {error ? (
            <>
              <h1>That link didn't work</h1>
              <p className="muted" style={{ margin: 0 }}>{error}</p>
              <Link to="/login" className="btn primary">
                Get a new link
              </Link>
            </>
          ) : (
            <p className="muted" style={{ margin: 0 }}>Signing you in…</p>
          )}
        </div>
      </div>
    </div>
  );
}
